import { useContext, useEffect, useState } from 'react'
import AppContext from '../../context/AppContext'
import { PaymentMethodCartData } from '../../interfaces/carts'
import { calculateProductsTotalPrice, calculateTotalDiscountsByProvider } from '../../utils/functions/calculatePrices'

interface ProviderMinimumIssue {
  name: string
  currentTotal: number
  minimum: number
  providerId: string
}

function useCheckProvidersMinimumPrice(paymentMethodData: PaymentMethodCartData) {
  const { cartData } = useContext(AppContext)
  const [disabledButton, setDisabledButton] = useState<boolean>(false)
  const [providersWithIssues, setProvidersWithIssues] = useState<ProviderMinimumIssue[]>([])

  const checkProvidersMinimumPrice = (): { hasIssues: boolean; issues: ProviderMinimumIssue[] } => {
    const issues: ProviderMinimumIssue[] = []
    
    for (const provider of paymentMethodData.providers) {
      const total: number =
        calculateProductsTotalPrice(provider.products) -
        calculateTotalDiscountsByProvider(cartData.discounts, provider._id)

      if (total < provider.minimum) {
        issues.push({
          name: provider.name,
          currentTotal: total,
          minimum: provider.minimum,
          providerId: provider._id,
        })
      }
    }

    return { hasIssues: issues.length > 0, issues }
  }

  useEffect(() => {
    const result = checkProvidersMinimumPrice()
    setDisabledButton(result.hasIssues)
    setProvidersWithIssues(result.issues)
  }, [cartData]) 

  return { disabledButton, providersWithIssues }
}

export default useCheckProvidersMinimumPrice
